import { FormatPhonePipe } from './format-phone.pipe';
import { FormatReminderDatePipe } from './format-reminder-date.pipe';
import { IBANPipe } from './iban.pipe';
import { TranslateDatePipe } from './translate-date.pipe';
import { TranslateNumberPipe } from './translate-number.pipe';
import { TranslatePercentPipe } from './translate-percent.pipe';

export const pipes = [FormatPhonePipe, TranslateDatePipe, TranslateNumberPipe, TranslatePercentPipe, FormatReminderDatePipe, IBANPipe];

export { FormatPhonePipe } from './format-phone.pipe';
export { FormatReminderDatePipe } from './format-reminder-date.pipe';
export { IBANPipe } from './iban.pipe';
export { TranslateDatePipe } from './translate-date.pipe';
export { TranslateNumberPipe } from './translate-number.pipe';
export { TranslatePercentPipe } from './translate-percent.pipe';
